



import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";

export default class GrantWorkSpaceComponent extends Vue {
    
}
